import Footer from "../components/Footer.component";
import Navbar from "../components/Navbar.component";
import { Box } from "@mui/material";

const ResetPasswordMesage = () => {
  const styles: any = {
    width: "60%",
    marginInline: "auto",
    textAlign: "center",
  };
  return (
    <>
      <Navbar />
      <Box style={styles}>
        <h1>Password Reset Sent</h1>
        <p>
          We just sent a message to the email you provided with a link to reset
          your password. Please check your inbox and follow the instructions in
          the email.
        </p>
      </Box>
      <Footer />
    </>
  );
};

export default ResetPasswordMesage;
